module.exports = __webpack_public_path__ + "static/media/400336_02.265ac97e.png";